import { render, staticRenderFns } from "./IconRecipe.vue?vue&type=template&id=5186a8e3&"
import script from "./IconRecipe.vue?vue&type=script&lang=ts&"
export * from "./IconRecipe.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports